import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import "./SpecialFacility.css";
import Aos from 'aos';
import './aos.css';
import React, { useState, useEffect } from 'react';

function ShapeExample() {
  useEffect(() => {
    Aos.init({});
  }, [])
  return (
    <Container className="my-5">
      <Row>
        <Col xs={6} md={6}>
          <div data-aos="flip-left" data-aos-duration="2500">
            <Image
              src="imagesspecialfacilities/club.png"
              rounded
              style={{ width: '100%', objectFit: 'cover', marginTop: '30px', boxShadow: ' rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px, rgba(0, 0, 0, 0.35) 0px 5px 15px' }}
            />
          </div>
        </Col>
        <Col xs={6} md={6}>
          <div className="facility-text">
            <h2 className="facility-title">Clubs</h2>
            <p>
              At ACE International Academy, we understand that connecting with other
              students is one of the most important parts of a great school
              experience. That’s why we offer a multitude of physical and
              non-physical clubs designed to challenge and extend learning through
              these extra-curricular activities. These teacher-directed student
              engagement activities include basketball, volleyball, cricket, table
              tennis, snooker, football, dance, badminton, home economics, art and
              craft, media, choir, science, computer game programming, board games,
              painting, martial arts, robotics, drama and oratory club.

            </p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={6} md={12}>
          <div className="facility-text" >
            <br />
            <p>These teacher-directed student engagement activities include basketball, volleyball, cricket, table tennis, snooker, football, dance, badminton, home economics, art and craft, media, choir, science, computer game programming, board games, painting, martial arts, robotics, drama and oratory club.</p>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default ShapeExample;
